import { createRootRoute, Outlet } from '@tanstack/react-router'
import { useState, useCallback } from 'react'
import { useAuth_M1_2 } from '@/contexts/AuthProvider'
import { AppLayout_M10_18 } from '@/components/layout/AppLayout'
import { LoadingScreen_M10_11 } from '@/components/domain/LoadingScreen'
import { AgeVerification_M10_12 } from '@/components/domain/AgeVerification'
import { OnboardingFlow_M10_32 } from '@/components/domain/OnboardingFlow'

const ONBOARDING_KEY = 'kinkup_onboarded'

function RootComponent_M10_19() {
  const { isLoaded, isSignedIn, ageVerified, verifyAge } = useAuth_M1_2()
  const [onboarded, setOnboarded] = useState(() => localStorage.getItem(ONBOARDING_KEY) === '1')

  const completeOnboarding = useCallback(() => {
    localStorage.setItem(ONBOARDING_KEY, '1')
    setOnboarded(true)
  }, [])

  if (!isLoaded) {
    return <LoadingScreen_M10_11 />
  }

  if (!ageVerified) {
    return <AgeVerification_M10_12 open={true} onVerified={verifyAge} />
  }

  if (!onboarded) {
    return <OnboardingFlow_M10_32 onComplete={completeOnboarding} />
  }

  if (!isSignedIn) {
    return <Outlet />
  }

  return <AppLayout_M10_18 />
}

export const Route = createRootRoute({
  component: RootComponent_M10_19,
})
